import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Brain, CheckCircle2, Loader2 } from "lucide-react";

const STEPS = (industry) => [
  "Reviewing your business profile",
  `Comparing against ${industry || "industry"} benchmarks`,
  "Scoring data, automation & AI readiness",
  "Identifying high-impact AI opportunities",
  "Building your 12-month roadmap"
];

export default function AILoader({ industry }) {
  const steps = STEPS(industry);
  const [active, setActive] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setActive(a => Math.min(a + 1, steps.length - 1)), 4500);
    return () => clearInterval(t);
  }, [steps.length]);

  return (
    <div className="loader-screen">
      <div className="loader-card">
        <motion.div
          className="loader-orb"
          animate={{ scale: [1, 1.06, 1] }}
          transition={{ repeat: Infinity, duration: 1.8, ease: "easeInOut" }}
        >
          <Brain size={42} />
        </motion.div>
        <h2>Analysing your business…</h2>
        <p>Our AI is preparing your personalised report. This usually takes 20–40 seconds.</p>

        <div className="loader-steps">
          {steps.map((label, i) => {
            const state = i < active ? "done" : i === active ? "active" : "";
            return (
              <div key={label} className={`loader-step ${state}`}>
                <span className="ic">
                  {i < active ? <CheckCircle2 size={18} /> : i === active ? <Loader2 size={18} className="spin" /> : "•"}
                </span>
                {label}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
